.innerCarouselItem {
  width: 100%;
  min-width: 100%;
  aspect-ratio: 160 / 39;
  position: relative;
}

.innerCarouselImg {
  width: 100%;
  height: 100%;
}

.itemContainer {
  min-height: 251px;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  cursor: default;
}

@media all and (--reefer-media-desktop-sm-min) {
 .innerCarouselItem {
   aspect-ratio: 149 / 36;
 }
}
